import { API_URL } from "../../../services";
import { ReportOwnSalesProps } from "../reports.props";
import ReportSalesTable from "./ReportSalesTable";

// Ventas propias (canal): operaciones de sus apiUsers.
const ReportOwnSales: React.FC<ReportOwnSalesProps> = (props) => (
  <ReportSalesTable
    {...props}
    endpoint={API_URL.OWN_SALES}
    allowedRoles={["channel"]}
  />
);

export default ReportOwnSales;
